module.exports = __webpack_public_path__ + "static/media/clientTwo.8bcf130a.webp";